import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {Store} from '@ngrx/store';

import {catchError, Observable, of, tap} from 'rxjs';
import {AppSettingReq, AppSettingRes} from '../models';
import {GeneralService} from '../services/general/general.service';
import {StoreAppSettings} from '../store';
import Storage from '../utils/storage';

@Injectable({
  providedIn: 'root',
})
export class AppSettingsResolver  {
  constructor(
    private readonly generalService: GeneralService,
    private _store$: Store
  ) {}
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<AppSettingRes | null> {
    const body: AppSettingReq = new AppSettingReq();
    body.CartId = Storage.get('cartId', 0);
    return this.generalService.getAppSetting(body).pipe(
      tap((res) => {
        this._store$.dispatch(StoreAppSettings({ payload: res }));
      }),
      catchError((error) => {
        return of(null);
      })
    );
  }
}
